


































































































import { Vue, Component, Prop } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import { Route } from 'vue-router'
import store from '@/store'
import dayjs from 'dayjs'
import { MedicineDataForCalencer } from '@/store/dispensation/types'
import { weekOfYear } from '@/utils/index'

const TODAY = dayjs()

const handleChangeRounting = async (to: Route, next: () => void) => {
  const user = store.getters['user/userInfo']
  const relative = store.getters['user/relativeInfo']
  const patientId = user.isPatientRelative ? relative?.patient?.id : user.id
  const year = Number(to.query.year || TODAY.year())
  if (patientId == null) return
  await store.dispatch('dispensation/fetch', { patientId, year })
  next()
}

@Component
export default class DispensationCalendar extends Vue {
  @Prop(Number) readonly year!: number | null

  $store!: ExStore

  get userInfo() {
    return this.$store.getters['user/userInfo']
  }

  get isRelative() {
    return this.userInfo.isPatientRelative
  }

  get routePrefix() {
    return this.isRelative ? 'Relative' : 'Patient'
  }

  get yearOptions() {
    const start = 2018
    const end = TODAY.year()
    return [...new Array(end - start + 1)].map((_, i) => end - i)
  }

  get selectedYear() {
    return this.year || TODAY.year()
  }

  set selectedYear(year) {
    this.$router.push({
      name: `${this.routePrefix}DispensationCalendar`,
      query: { year: String(year) }
    })
  }

  get sameEffectMedicineGroups() {
    return this.$store.getters['dispensation/sameEffectMedicineGroups']
  }

  get disp() {
    return this.$store.getters['dispensation/dispensationWeeklyGroups']
  }

  get calenderSort() {
    return this.$store.getters['dispensation/calenderSort']
  }

  get labotestWeeklyGroups() {
    return this.$store.getters['labotest/labotestWeeklyGroups']
  }

  get wholeWeeks() {
    const lastweek = dayjs(`${this.selectedYear}-12-31`).week()
    const numWeeks = lastweek === 1 ? 53 : lastweek
    return [...new Array(numWeeks)].map((_, i) => i + 1)
  }

  get wom2woy() {
    const selected = dayjs(`${this.selectedYear}-01-01`)
    const diff = selected.day()
    const start = selected
    return this.wholeWeeks.reduce((group, weekOfYear) => {
      let date = start.add(weekOfYear - 1, 'week').subtract(diff, 'day')
      if (date.year() < this.selectedYear)
        date = dayjs(`${this.selectedYear}-01-01`)
      if (date.year() > this.selectedYear)
        date = dayjs(`${this.selectedYear}-12-31`)
      const month = date.month()

      if (!group[month]) {
        group[month] = []
      }

      group[month].push(weekOfYear)

      return group
    }, [] as Array<Array<number>>)
  }

  getCellClasses(
    medicine: MedicineDataForCalencer | undefined,
    yjCode: string
  ) {
    const classes: string[] = []

    if (!medicine) {
      return classes
    }

    if (this.isNew(medicine)) {
      classes.push('bg_pink')
    } else {
      classes.push('bg_lightblue')
    }

    return classes
  }

  isNew(medicine: MedicineDataForCalencer) {
    return medicine.diffMark === '新規'
  }

  isDuplicatedSameEffectItem(
    medicine: MedicineDataForCalencer,
    yjCode1: string
  ) {
    if (medicine.index > 0) {
      return false
    }

    const key = yjCode1.substr(0, 7)
    const sameEffect = this.sameEffectMedicineGroups[key]
    const { dispensationDate, daysTimes } = medicine
    const startOfTerm = dispensationDate.dayOfYear()
    const endOfTerm = startOfTerm + daysTimes

    return Object.keys(sameEffect).some(yjCode2 => {
      if (yjCode2 === yjCode1) {
        return false
      }

      return sameEffect[yjCode2].some(
        ({ start, end }) =>
          (startOfTerm >= start && startOfTerm <= end) ||
          (endOfTerm >= start && endOfTerm <= end)
      )
    })
  }

  async beforeRouteEnter(to: Route, from: Route, next: () => void) {
    await handleChangeRounting(to, next)
  }

  async beforeRouteUpdate(to: Route, from: Route, next: () => void) {
    await handleChangeRounting(to, next)
  }
}
